import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { TableData } from 'utils/data'

export const fetchSafetyLagging = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
export const fetchSafetyTotal = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/safety/total/`,
)
export const fetchSafetyLeading = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/safety/leading/`,
)
export const fetchSafetyStoreLagging = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
export const fetchSafetyStoreTotal = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
export const fetchSafetyStoreLeading = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
